<template>
  <el-row :key="updateKey">
    <el-col :span="24">
      <el-form-item label="宽度">
        <el-input-number
          v-model="layoutConfig.w"
          :controls="false"
          :min="10"
          :max="375"
          class="w-full"
          @change="(curVal, oldVal) => numChange('w', curVal, oldVal)"
        />
      </el-form-item>
      <el-form-item label="高度" v-if="!config.isAdaptive">
        <el-input-number
          v-model="layoutConfig.h"
          :controls="false"
          :min="10"
          class="w-full"
          @change="(curVal, oldVal) => numChange('h', curVal, oldVal)"
        />
      </el-form-item>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      default: () => {
        return {
          w: 10,
          h: 10,
          x: 0,
          y: 0,
          isAdaptive: false, // 是否自适应
        }
      },
    },
    layout: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      layoutConfig: {},
      updateKey: _.random(5000),
    }
  },
  watch: {
    config: {
      deep: true,
      handler(val) {
        this.layoutConfig = _.cloneDeep(val)
      },
    },
  },
  methods: {
    numChange(key, curVal, oldVal) {
      if (!_.isNumber(curVal)) {
        this.$set(this.layoutConfig, key, oldVal)
        this.updateKey = _.random(5000)
        return
      }
      this.$emit('layoutChange', this.layoutConfig)
    },
  },
  mounted() {
    this.layoutConfig = _.cloneDeep(this.config)
  },
}
</script>

<style></style>
